/** The fixed copy of the card form and its states (2.M deliverables 15, 19 and 21); US English. */
export const COPY = {
  frame: 'Card',
  title: { spell: 'Spell card', item: 'Item card' },
  newCard: { spell: 'New spell card', item: 'New item card' },
  loading: 'Loading card…',
  off: 'Card forms are turned off.',
  srd: "SRD entries can't be edited. Customize makes an editable copy.",
  noCard: (typeName: string) => `${typeName} pages don't have cards.`,
  missing: "This page doesn't exist.",
  failed: "The card couldn't be loaded.",
  saved: 'Card saved.',
  leaveTitle: 'Leave without saving?',
  leaveBody: 'Your changes to this card will be lost.',
  conflict: 'This card was changed elsewhere.',
  lastValid: 'Showing the last valid version',
  noPreview: 'Fix the marked fields to see the preview.',
  fixFirst: 'Fix the marked fields before saving.',
  createFailed: "The page couldn't be created. Try again.",
  loadFailed: "Couldn't load the saved version.",
  compareLoading: 'Loading the SRD entry…',
  compareMissing: 'The SRD entry this was copied from no longer exists.',
  compareFailed: "Couldn't load the SRD entry.",
  compareWithdrawn: 'The SRD entry this was copied from was withdrawn.',
  compareSame: 'No differences from the SRD entry.',
} as const;
